import AmbassadorsPayouts from './AmbassadorsPayouts'

export default AmbassadorsPayouts
// eslint-disable-next-line import/export
export * from './AmbassadorsPayouts'
